<template>
    <div class="item-wrap user-detail-wrap pos-r">
        <div class="board td-f">
            <div class="avatar">
                <img :src="dataSources.cover || dataSources.inheritor_cover" />
            </div>
            <div class="info td-f1 td-fc td-fas">
                <div class="name">
                    <span>{{dataSources.title || dataSources.inheritor_name}}</span>
                    <span>{{dataSources.inheritor_level}}</span>
                </div>
                <div class="mobile">{{dataSources.introduce}}</div>
            </div>
        </div>
        <div class="content" v-if="user_type == Constants.USER_MASTER">{{dataSources.inheritor_introduce}}</div>
        <div class="content" v-html="dataSources.rich_text"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import {wxSetup, wxShare} from '@/utils/wxShare'
export default {
    computed: {
        ...mapGetters(["userInfo", "service"]),
    },
    data() {
        return {
            loading: false,
            dataSources: {},
            user_id: this.$route.query.user_id || '',
            user_type: this.$route.query.user_type || this.Constants.USER_MASTER,
            page: 1,
            limit: 10,
        };
    },
    mounted() {
        this._requestDataSources();
        setTimeout(() => {
            this._setupWechatConfig();
        }, 500);
    },
    methods: {

        // 设置分享参数
        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'common',
                share_url: window.location.href.split('#')[0],
            };

            let _urlTemp = window.location.href;
            if (_urlTemp.indexOf('is_share=1&uid=') > -1) {
                _urlTemp = _urlTemp.split('is_share=1&uid=')[0] + 'is_share=1&uid=' + this.userInfo.id;
            } else {
                _urlTemp = _urlTemp + '&is_share=1&uid=' + this.userInfo.id;
            }

            console.log('this.userInfo, _urlTemp---->', this.userInfo, _urlTemp);

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                let share_params = {
                    ...result.data.share_params,
                    title: this.dataSources.name,
                    desc: this.dataSources.desc,
                    icon: this.dataSources.cover,
                    link: _urlTemp,
                }
                wxShare(result.data.share_config, share_params, () => {});
            }
        },
        
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        async _requestDataSources() {
            let {
                user_id,
                user_type,
                dataSources
            } = this;
            let url = this.API.master_user_detail;
            let data = {
                user_id,
                user_type,
            };
            const result = await this.$post(url, data);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data;
            }
        },

    },
};
</script>

<style lang="less" scoped>
.user-detail-wrap {
    .board {
        margin-bottom: 10px;
        background-color: #fff;
        border-radius: 6px;
        padding: 20px;

        .avatar {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
            }
        }

        .info {
            margin-left: 20px;

            .name {
                font-size: 16px;
                color: #333;
                font-weight: 600;

                .level {
                    color: #6472e8;
                    padding-left: 10px;
                }
            }

            .mobile {
                font-size: 14px;
                color: #888;
            }
        }
    }

    .content {
        border-radius: 6px;
        background-color: #fff;
        padding: 20px;
        font-size: 15px;
        color: #333;
        line-height: 2;
        text-align: justify;
        word-break: break-all;
    }
}
</style>